import { airportInformationSchema } from "../../forms/privateAviation/user/formSchema";
import AirportInformation from "../../forms/privateAviation/user/steps/AirportInformation";
import EditSectionPage from "./EditSectionPage";

const AirportInformationEditPage = () => {
  return (
    <EditSectionPage
      title="Airport Information"
      schema={airportInformationSchema}
      step={4}
    >
      <AirportInformation />
    </EditSectionPage>
  );
};

export default AirportInformationEditPage;
